<template>
  <v-dialog v-model="dialogs" width="388">
    <v-card class="pb-1">
      <v-date-picker
        v-model="date"
        header-color="#718FC7"
        width="388"
        :title-date-format="getTitleDate"
        :weekday-format="getDay"
        :month-format="getMonth"
        :header-date-format="getHeaderDate"
      >
        <template class>
          <div
            class="d-flex justify-space-between align-center"
            style="width:100%;"
          >
            <div class="d-flex">
              <v-btn
                color="#3F557D"
                class="color-white"
                rounded
                width="142"
                height="42"
                @click="confirmDate(date)"
                >선택완료
              </v-btn>
              <v-btn
                @click="dialogs = false"
                color="#DADADA"
                class="color-white "
                rounded
                width="142"
                height="42"
                >닫기
              </v-btn>
            </div>
            <v-btn
              color="#3F557D"
              class="color-white"
              rounded
              width="76"
              height="30"
              @click="confirmDate('')"
            >
              초기화
            </v-btn>
          </div>
        </template>
      </v-date-picker>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["statement", "sendDialog"],
  data: () => ({
    date: "",
    dialogs: false,
  }),

  watch: {
    sendDialog: function(val) {
      if (val == true) this.dialogs = val;
    },
    dialogs: function() {
      this.$emit("datefunction", false);
    },
  },
  methods: {
    confirmDate(val) {
      this.$emit("date", val);
      this.sendDialog = false;
      this.dialogs = false;
    },
    getDay(date) {
      const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
      let week = new Date(date).getDay(date);
      return daysOfWeek[week];
    },
    getMonth(date) {
      const monthName = [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월",
      ];
      let month = new Date(date).getMonth(date);
      return monthName[month];
    },
    getHeaderDate(date) {
      const [year, month] = date.split("-");
      return month ? `${year}년 ${month}월` : `${year}년`;
    },
    getTitleDate(date) {
      const parsedDate = new Date(date);
      const month = parsedDate.getMonth() + 1; // 월은 0부터 시작하므로 +1 필요
      const day = parsedDate.getDate(); // 일
      return `${month}월 ${day}일`;
    },
  },
};
</script>
